var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container bj-label-colon" },
    [
      _c(
        "BjDivider",
        {
          attrs: { "right-fixed": "" },
          scopedSlots: _vm._u([
            {
              key: "right",
              fn: function () {
                return [
                  _vm.info.sourcingStatus == "30303"
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onAppointDelivery },
                        },
                        [_vm._v(_vm._s(_vm.$t("SourcingDetails.Specify")))]
                      )
                    : _vm._e(),
                  _c("el-button", { on: { click: _vm.handleClose } }, [
                    _vm._v(_vm._s(_vm.$t("backText"))),
                  ]),
                  _c("BjLogButton", {
                    attrs: {
                      type: "order",
                      "default-query": {
                        innerOrderNo: _vm.info.innerOrderSn,
                        action: "AUTO_SOURING", //寻源动作
                      },
                      permission: "BusinessOrderSourceIndex_Log",
                      title: _vm.info.innerOrderSn,
                      api: "orderApi",
                    },
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [_vm._v(_vm._s(_vm.$t("SourcingDetails.Basic")) + " ")]
      ),
      _c("div", { staticClass: "bj-row border-no padding-no mt20" }, [
        _c(
          "div",
          { staticClass: "bj-col bj-col-18 padding-no bj-item-col-12" },
          [
            _c(
              "el-form",
              { ref: "form", attrs: { inline: "", "label-width": "200px" } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SourcingDetails.order") } },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "link",
                        on: {
                          click: function ($event) {
                            return _vm.$toBusinessThirdOrderView(
                              _vm.info.orderSn
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.info.orderSn))]
                    ),
                    _c("BjCopyIcon", { attrs: { copy: _vm.info.orderSn } }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SourcingDetails.Internal") } },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "link",
                        on: {
                          click: function ($event) {
                            return _vm.$toBusinessOrderInternalView(
                              _vm.info.innerOrderSn
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.info.innerOrderSn))]
                    ),
                    _c("BjCopyIcon", {
                      attrs: { copy: _vm.info.innerOrderSn },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SourcingDetails.Doc") } },
                  [
                    _c("span", [_vm._v(_vm._s(_vm.info.sourcingSn))]),
                    _c("BjCopyIcon", { attrs: { copy: _vm.info.sourcingSn } }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SourcingDetails.creation") } },
                  [_vm._v(" " + _vm._s(_vm.info.creationDate) + " ")]
                ),
                _vm.info.remarks
                  ? _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SourcingDetails.Reason") } },
                      [_vm._v(" " + _vm._s(_vm.info.remarks) + " ")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass:
              "bj-col bj-col-6 padding-no flex-column flex-center el-progress-box-2022-4-11",
          },
          [
            _c("el-progress", {
              attrs: {
                type: "circle",
                width: 160,
                "stroke-width": 30,
                percentage: _vm.progressPercentage,
                format: _vm.progressText,
              },
            }),
          ],
          1
        ),
      ]),
      _c("BjDivider", [_vm._v(_vm._s(_vm.$t("SourcingDetails.product")))]),
      _c("GoodsInfoTab", {
        attrs: {
          "order-id": _vm.$route.query.id,
          "object-version-number": _vm.info.objectVersionNumber,
          "has-btn": "",
        },
      }),
      _c("AppointDelivery", {
        ref: "specifyDelivery",
        on: { confirm: _vm.reFresh },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }